// extracted by mini-css-extract-plugin
module.exports = {"close":"CaseNavPanel_close__1NBc5","user":"CaseNavPanel_user__3M5Lh","name":"CaseNavPanel_name__DOTDT"};